module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "kpi_jefe",
    staticClass: "box position-relative"
  }, [_c('component-dashboard-kpi-jefe', {
    on: {
      "close": function($event) {
        return _vm.close('showKpiJefe')
      }
    }
  })], 1), (_vm.perfilVacaciones === 'recursos humanos' && _vm.showKpiRRHH) ? _c('div', {
    key: "kpi_rrhh",
    staticClass: "box position-relative"
  }, [_c('component-dashboard-kpi')], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-646183cc","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin_View.vue
// module id = 890
// module chunks = 0